export default __webpack_public_path__ + "files/media/fleet-ar-l.4466bd7b.jpg";